// SiteTypeSelector.js
import React from 'react';
import { Paper, Typography, FormControl, InputLabel, Select, MenuItem, Box, Chip, OutlinedInput } from '@mui/material';

export const SiteTypeSelector = ({ selectedSiteTypes, onChange, filteredLocations = [] }) => {
  // Calculate counts for each site type
  const siteCounts = selectedSiteTypes.reduce((acc, type) => {
    acc[type] = filteredLocations.filter(loc => loc.size === type).length;
    return acc;
  }, {});

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Site Types
      </Typography>
      <FormControl fullWidth>
        <InputLabel>Site Categories</InputLabel>
        <Select
          multiple
          value={selectedSiteTypes}
          onChange={onChange}
          input={<OutlinedInput label="Site Categories" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
        >
          {['Small', 'Medium', 'Large', 'DC'].map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      {/* Site type counts */}
      <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {selectedSiteTypes.map((type) => (
          <Typography key={type} variant="body2" color="text.secondary">
            {type}: {siteCounts[type]} sites
          </Typography>
        ))}
      </Box>
    </Paper>
  );
};